import { useState } from 'react';
import { BlockReason } from '@shared/api/rest/cards';
import { RadioInputOrientationTypeEnum } from '@shared/widgets/inputs/radio/models';
import { BaseInput, Button, Modal, RadioInput, Spinner, Text } from '@shared/widgets';

const REASONS = [
  { text: BlockReason.LOST, value: BlockReason.LOST },
  { text: BlockReason.STOLEN, value: BlockReason.STOLEN },
];

interface IReportModalProps {
  show: boolean;
  onClose: () => void;
  onSave: (reason: BlockReason, location?: string) => void;
  loading: boolean;
}

export const ReportModal = (props: IReportModalProps) => {
  const [reason, setReason] = useState<BlockReason>(BlockReason.LOST);
  const [location, setLocation] = useState<string>();

  const save = async () => {
    await props.onSave(reason, location);
    props.onClose();
  };

  return (
    <Modal isOpen={props.show} onClose={props.onClose} title='Report lost/stolen card'>
      {props.loading ? (
        <Spinner />
      ) : (
        <>
          <div className='mb-5'>
            <Text className='mb-2' size='sm'>
              Fraud reason
            </Text>
            <RadioInput
              options={REASONS}
              selected={reason}
              onChange={(val) => setReason(val as BlockReason)}
              orientation={RadioInputOrientationTypeEnum.Horizontal}
            />
          </div>
          <div className='mb-5'>
            <BaseInput className='text-2xl' type='text' placeholder="'Fraud location (optional)'" onChange={setLocation} value={location} />
          </div>
          <div className='mt-6'>
            <Button color='primary' fullWidth onClick={save}>
              Report
            </Button>
          </div>
        </>
      )}
    </Modal>
  );
};
